import { Images } from "../../../Images";
import BigNum from "../../math/BigNum";
import Values from "../../value/Values";
import UpgradeAutomationSkillNode from "./UpgradeAutomationSkillNode";
import { SkillIds } from "../SkillIds";
import SkillType from "../SkillType";
import AutomationUnlockSkillNode from "./AutomationUnlockSkillNode";

export default class MinedUpgradeAutomationSkill extends SkillType {
    /**
     * @param {Totals} totals
     * @param {Values} values
     */
    constructor(totals, values) {
        super(SkillIds.MINED_AUTOMATION);

        /**
         * @constant
         * @type {Values}
         */
        this.values = values;

        const inc = 5;
        let cost = 5;

        const minedAutomationUnlock = this.addNode(new AutomationUnlockSkillNode('minedAutomationUnlock', 'Auto Claim', 'Mined Upgrades', 
            totals, Images.pick, new BigNum(cost), this, this.values.minedAutomationUnlocked));

        cost += inc;

        const minedAutomationBonus1 = this.addNode(new UpgradeAutomationSkillNode('minedAutomationBonus1', 
            totals, Images.pick, new BigNum(cost), this, this.values.minedAutomationRateUpgrades
        ));

        cost += inc;

        const minedAutomationBonus2 = this.addNode(new UpgradeAutomationSkillNode('minedAutomationBonus2', 
            totals, Images.pick, new BigNum(cost), this, this.values.minedAutomationRateUpgrades
        ));

        cost += inc;

        const minedAutomationBonus3 = this.addNode(new UpgradeAutomationSkillNode('minedAutomationBonus3', 
            totals, Images.pick, new BigNum(cost), this, this.values.minedAutomationRateUpgrades
        ));

        cost += inc;

        const minedAutomationBonus4 = this.addNode(new UpgradeAutomationSkillNode('minedAutomationBonus4', 
            totals, Images.pick, new BigNum(cost), this, this.values.minedAutomationRateUpgrades
        ));

        cost += inc;

        const minedAutomationBonus5 = this.addNode(new UpgradeAutomationSkillNode('minedAutomationBonus5', 
            totals, Images.pick, new BigNum(cost), this, this.values.minedAutomationRateUpgrades
        ));

        cost += inc;

        const minedAutomationBonus6 = this.addNode(new UpgradeAutomationSkillNode('minedAutomationBonus6', 
            totals, Images.pick, new BigNum(cost), this, this.values.minedAutomationRateUpgrades
        ));

        cost += inc;

        const minedAutomationBonus7 = this.addNode(new UpgradeAutomationSkillNode('minedAutomationBonus7', 
            totals, Images.pick, new BigNum(cost), this, this.values.minedAutomationRateUpgrades
        ));

        cost += inc;

        const minedAutomationBonus8 = this.addNode(new UpgradeAutomationSkillNode('minedAutomationBonus8', 
            totals, Images.pick, new BigNum(cost), this, this.values.minedAutomationRateUpgrades
        ));

        cost += inc;

        const minedAutomationBonus9 = this.addNode(new UpgradeAutomationSkillNode('minedAutomationBonus9', 
            totals, Images.pick, new BigNum(cost), this, this.values.minedAutomationRateUpgrades
        ));

        cost += inc;

        const minedAutomationBonus10 = this.addNode(new UpgradeAutomationSkillNode('minedAutomationBonus10', 
            totals, Images.pick, new BigNum(cost), this, this.values.minedAutomationRateUpgrades
        ));

        cost += inc;

        const minedAutomationBonus11 = this.addNode(new UpgradeAutomationSkillNode('minedAutomationBonus11', 
            totals, Images.pick, new BigNum(cost), this, this.values.minedAutomationRateUpgrades
        ));

        cost += inc;

        const minedAutomationBonus12 = this.addNode(new UpgradeAutomationSkillNode('minedAutomationBonus12', 
            totals, Images.pick, new BigNum(cost), this, this.values.minedAutomationRateUpgrades
        ));


        minedAutomationUnlock.addChildNode(minedAutomationBonus1);

        minedAutomationBonus1.addChildNode(minedAutomationBonus2);
        minedAutomationBonus2.addChildNode(minedAutomationBonus3);
        minedAutomationBonus3.addChildNode(minedAutomationBonus4);
        minedAutomationBonus4.addChildNode(minedAutomationBonus5);
        minedAutomationBonus5.addChildNode(minedAutomationBonus6);
        minedAutomationBonus6.addChildNode(minedAutomationBonus7);
        minedAutomationBonus7.addChildNode(minedAutomationBonus8);
        minedAutomationBonus8.addChildNode(minedAutomationBonus9);
        minedAutomationBonus9.addChildNode(minedAutomationBonus10);
        minedAutomationBonus10.addChildNode(minedAutomationBonus11);
        minedAutomationBonus11.addChildNode(minedAutomationBonus12);

        ///////////////////////////////////
        // Position the nodes in the graph
        ///////////////////////////////////

        // Starting coordinate of the skill
        const startX = -1;
        const startY = 5;

        minedAutomationUnlock.setPosition(startX, startY);

        minedAutomationBonus1.setPosition(startX - 1, startY);
        minedAutomationBonus2.setPosition(startX - 2, startY);
        minedAutomationBonus3.setPosition(startX - 3, startY);
        minedAutomationBonus4.setPosition(startX - 4, startY);
        minedAutomationBonus5.setPosition(startX - 5, startY);
        minedAutomationBonus6.setPosition(startX - 6, startY);
        minedAutomationBonus7.setPosition(startX - 6, startY - 1);
        minedAutomationBonus8.setPosition(startX - 5, startY - 1);
        minedAutomationBonus9.setPosition(startX - 4, startY - 1);
        minedAutomationBonus10.setPosition(startX - 3, startY - 1);
        minedAutomationBonus11.setPosition(startX - 2, startY - 1);
        minedAutomationBonus12.setPosition(startX - 1, startY - 1);

    }
    
}